import { Editor, Path, Text, Transforms } from 'slate';
import EditorUtils from '../../../AhaEditorUtils/EditorUtils';
import { ReactEditor } from 'slate-react';
import { type EventHandlerParams } from './types';

const handleArrowDown = ({
  editor,
  event,
  currentBlock,
  isVoid,
}: EventHandlerParams) => {
  const [, currentBlockPath] = currentBlock;
  const nextEntry = Editor.next(editor, { at: currentBlockPath });

  if (!isVoid) {
    if (Path.equals(currentBlockPath, [editor.children.length - 1])) return;

    const nextEntry = Editor.next(editor, { at: currentBlockPath });
    if (!nextEntry) return;

    const nextNode = nextEntry[0];
    const siblingIsVoid =
      !Editor.isEditor(nextNode) &&
      !Text.isText(nextNode) &&
      Editor.isVoid(editor, nextNode);

    if (!siblingIsVoid) return;
  }

  const targetPath = Path.next(currentBlockPath);
  // If the next block is empty, insert an empty paragraph
  if (!nextEntry) {
    Transforms.insertNodes(editor, EditorUtils.emptyParagraph(), {
      at: targetPath,
    });
  }
  Transforms.select(editor, Editor.point(editor, targetPath));

  event.preventDefault();
  ReactEditor.focus(editor);
  return true;
};

export default handleArrowDown;
